import { usePathname } from 'next/navigation';
import { getCanonicalPath, getAllLocalizedPaths } from '../i18n/pathnames';
import { localizePathFor, localizeFullPathFor } from '../i18n/localizePath';
import { Locale, defaultLocale, locales } from '../i18n/config';

export function useLocalizedPath() {
  const pathname = usePathname();
  const pathSegments = pathname?.split('/').filter(Boolean) || [];
  const locale = (pathSegments[0] && locales.includes(pathSegments[0] as Locale)
    ? pathSegments[0]
    : defaultLocale) as Locale;

  const localizePath = (canonicalPath: string): string =>
    localizePathFor(locale, canonicalPath);

  const localizeFullPath = (canonicalPath: string): string =>
    localizeFullPathFor(locale, canonicalPath);

  const getCanonical = (localizedPath: string): string => {
    return getCanonicalPath(localizedPath, locale);
  };

  const getAllAlternates = (canonicalPath: string) => {
    return getAllLocalizedPaths(canonicalPath);
  };

  return {
    locale,
    localizePath,
    localizeFullPath,
    getCanonical,
    getAllAlternates,
  };
}
